<script>
  import BulkPricingModal from '../BulkPricingModal.svelte';
  import { designState } from '../../stores/Designer.js';

  let showPricingModal = false;
</script>

<div class="design-selling-points">
  <div class="heading">100% Satisfaction Guaranteed</div>
  <div class="bullet-points">
    <div class="list-item">Free artwork and design service</div>
    <div class="list-item">Free logo correction</div>
    <div class="list-item">Trackable shipping</div>
    <div class="list-item">Dedicated representative</div>
    <div class="list-item">Fastest turnaround</div>
    <div class="list-item">No minimums</div>
  </div>
</div>

<style>
  .design-selling-points {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #f8f8f8;
    border-radius: 5px;
  }

  .design-selling-points .heading {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .bullet-points {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .list-item {
    display: list-item;
    list-style-position: inside;
  }
</style>
